import { useNavigate } from "react-router-dom";
import { CircularProgress } from "@mui/material";

import { ArrowLeftCircle } from "../../Assets/Icons";

function NeighborhoodNetworkRewards() {
  const navigate = useNavigate();

  return (
    <div className="neighborhood-network rewards">
      <section className="card-section-wrapper">
        <div className="max-width-container">
          <div className="card-section">
            <div className="section-header">
              <button className="go-back-button" onClick={() => navigate(-1)}>
                <ArrowLeftCircle />
              </button>
              <h3 className="section-title">My Rewards</h3>
              <div className="dummy"></div>
            </div>
            {false ? (
              <div className="loading-content">
                <CircularProgress />
              </div>
            ) : (
              <>
                <div className="fidel-reward">
                  <div className="reward-info">
                    <div className="reward-name">Embers Tap House</div>
                    <div className="reward-amount">$5.00</div>
                  </div>
                  <span className="rewarded-on">September 02, 2025 09:36</span>
                </div>
                <div className="fidel-reward">
                  <div className="reward-info">
                    <div className="reward-name">Embers Tap House</div>
                    <div className="reward-amount">$5.00</div>
                  </div>
                  <span className="rewarded-on">September 02, 2025 09:36</span>
                </div>
              </>
            )}
          </div>
        </div>
      </section>
    </div>
  );
}

export default NeighborhoodNetworkRewards;
